import PropTypes from "prop-types";
import { Box, Chip, Typography } from "@mui/material";
export default function RoleChangeSummary({ changes, nameChanged }) {
  const added = changes.filter((change) => change.enabled);
  const removed = changes.filter((change) => !change.enabled);
  return (
    <Box sx={{ minWidth: 0 }} aria-live="polite">
      <Typography variant="body2" fontWeight={600}>
        {changes.length
          ? `${added.length} accesos por agregar · ${removed.length} por quitar`
          : nameChanged
          ? "Nombre del rol modificado"
          : "Sin cambios pendientes"}
      </Typography>
      {!!changes.length && (
        <Box component="details" sx={{ mt: 0.5 }}>
          <Typography
            component="summary"
            variant="caption"
            sx={{ cursor: "pointer", color: "info.main" }}
          >
            Ver cambios
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              mt: 1,
              maxHeight: 100,
              overflowY: "auto",
            }}
          >
            {changes.map((change) => (
              <Chip
                key={change.key}
                size="small"
                variant="outlined"
                color={change.enabled ? "success" : "error"}
                label={`${change.enabled ? "+" : "−"} ${change.name}`}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
}
RoleChangeSummary.propTypes = {
  changes: PropTypes.array.isRequired,
  nameChanged: PropTypes.bool.isRequired,
};
